var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#073C50",
    fillRule: "evenodd",
    d: "M24,8 C36.7960804,8 46.7018128,22.5340519 47.1180794,23.1502205 L47.1180794,23.1502205 L48,24.4625184 L47.1180794,25.7748163 C46.7018128,26.3909848 36.7960804,40.9250367 24,40.9250367 C11.2039196,40.9250367 1.29818716,26.3909848 0.881920627,25.7748163 L0.881920627,25.7748163 L-2.59348099e-13,24.4625184 L0.881920627,23.1502205 C1.29818716,22.5340519 11.2039196,8 24,8 Z M24,12.7035767 C15.6676139,12.7035767 8.31827536,21.144145 5.75247428,24.4601666 C8.32297893,27.7738364 15.6934836,36.2214601 24,36.2214601 C32.3323861,36.2214601 39.6817246,27.7808917 42.2475257,24.4648702 C39.6770211,21.1512004 32.3065164,12.7035767 24,12.7035767 Z M24,15.055365 C29.1880451,15.055365 33.4071534,19.2744733 33.4071534,24.4625184 C33.4071534,29.6505634 29.1880451,33.8696717 24,33.8696717 C18.8119549,33.8696717 14.5928466,29.6505634 14.5928466,24.4625184 C14.5928466,19.2744733 18.8119549,15.055365 24,15.055365 Z M24,19.7589417 C21.4059775,19.7589417 19.2964233,21.8684958 19.2964233,24.4625184 C19.2964233,27.0565409 21.4059775,29.1660951 24,29.1660951 C26.5940225,29.1660951 28.7035767,27.0565409 28.7035767,24.4625184 C28.7035767,21.8684958 26.5940225,19.7589417 24,19.7589417 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.45ffe42712f6a1fbcb668412e7c43e68.svg";
export { ForwardRef as ReactComponent };